import React from 'react';
import { UploadDocumentButton } from 'framework/documentStorage';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { COMPLIANCE_DOCUMENT_STATUS, UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS } from 'domain/shared/compliance';
import ComplianceDocumentForm from 'domain/compliance/complianceRegistry/createupdate/ComplianceDocumentForm';

const UploadComplianceRegistryButton = () => {
  const { uploadDocument, getValidationSchema } = useDocumentStorageContext();

  return (
    <UploadDocumentButton
      permission={UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS}
      uploadMethod={uploadDocument}
      getValidationSchemaFunc={getValidationSchema}
      title="Publish: New compliance document"
      buttonText="New compliance document"
      sxButton={{
        fontSize: '14px',
      }}
      initialData={{
        paths: [],
        status: COMPLIANCE_DOCUMENT_STATUS.UNPUBLISHED,
      }}
      isHideDefaultButtons
    >
      <ComplianceDocumentForm />
    </UploadDocumentButton>
  );
};

export default UploadComplianceRegistryButton;
